import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import MaintenanceGate from "@/components/MaintenanceGate";
import Home from "@/pages/Home";
import Entreprise from "@/pages/Entreprise";
import Metiers from "@/pages/Metiers";
import Realisations from "@/pages/Realisations";
import RealisationDetail from "@/pages/RealisationDetail";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Lazy-load admin pages (not needed for public visitors → faster initial bundle)
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const AdminRealisations = lazy(() => import("@/pages/AdminRealisations"));
const AdminSettings = lazy(() => import("@/pages/AdminSettings"));
const AdminContent = lazy(() => import("@/pages/AdminContent"));
const PreviewSimulateur = lazy(() => import("@/pages/PreviewSimulateur"));

const AdminFallback = () => (
  <div className="min-h-screen flex items-center justify-center text-gray-400 text-sm tracking-wider uppercase">Chargement…</div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <ErrorBoundary>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route element={<MaintenanceGate />}>
              <Route path="/" element={<Home />} />
              <Route path="/entreprise" element={<Entreprise />} />
              <Route path="/metiers" element={<Metiers />} />
              <Route path="/realisations" element={<Realisations />} />
              <Route path="/realisations/:slug" element={<RealisationDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/confidentialite" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<Suspense fallback={<AdminFallback />}><AdminLogin /></Suspense>} />
            <Route path="/admin" element={<Suspense fallback={<AdminFallback />}><AdminDashboard /></Suspense>} />
            <Route path="/admin/realisations" element={<Suspense fallback={<AdminFallback />}><AdminRealisations /></Suspense>} />
            <Route path="/admin/parametres" element={<Suspense fallback={<AdminFallback />}><AdminSettings /></Suspense>} />
            <Route path="/admin/contenu" element={<Suspense fallback={<AdminFallback />}><AdminContent /></Suspense>} />
            <Route path="/preview/simulateur" element={<Suspense fallback={<AdminFallback />}><PreviewSimulateur /></Suspense>} />
          </Routes>
        </BrowserRouter>
        </ErrorBoundary>
      </div>
    </HelmetProvider>
  );
}

export default App;
